import React from 'react';
import { MapPin, Phone, Mail, Clock, Sparkles, ArrowRight, ShieldCheck } from 'lucide-react';
import ContactForm from '../../components/contact/ContactForm';
import styles from './contact.module.css';

const ContactPage = () => {
  return (
    <div className={styles.page}>
      {/* Hero Banner */}
      <div className={styles.heroBanner}>
        <div className={styles.heroContent}>
          <div className={styles.heroBadge}>
            <Sparkles size={13} />
            <span>Support &amp; Inquiries</span>
          </div>

          <h1 className={styles.heroTitle}>Get in Touch with B4BARBER</h1>

          <p className={styles.heroSubtitle}>
            Have questions about an appointment, need assistance with your salon account, or want to
            partner with our network? We're here to help.
          </p>
        </div>
      </div>

      {/* Main Grid */}
      <div className={styles.contactGrid}>
        {/* Left Column: Direct Contact Details */}
        <div className={styles.infoColumn}>
          <div className={styles.infoCard}>
            <div className={styles.iconBox}>
              <MapPin size={22} />
            </div>
            <div className={styles.infoContent}>
              <h3 className={styles.infoTitle}>Headquarters</h3>
              <p className={styles.infoText}>Noida, Sector 63, Uttar Pradesh, India 201301</p>
            </div>
          </div>

          <div className={styles.infoCard}>
            <div className={styles.iconBox}>
              <Phone size={22} />
            </div>
            <div className={styles.infoContent}>
              <h3 className={styles.infoTitle}>Customer Care</h3>
              <p className={styles.infoText}>
                Direct Helpline:{' '}
                <a href="tel:+918540843859" className={styles.infoLink}>
                  +91 8540843859
                </a>
              </p>
            </div>
          </div>

          <div className={styles.infoCard}>
            <div className={styles.iconBox}>
              <Mail size={22} />
            </div>
            <div className={styles.infoContent}>
              <h3 className={styles.infoTitle}>Email Support</h3>
              <p className={styles.infoText}>
                General &amp; Bookings:{' '}
                <a href="mailto:info@timetofuture.com" className={styles.infoLink}>
                  info@timetofuture.com
                </a>
              </p>
            </div>
          </div>

          <div className={styles.infoCard}>
            <div className={styles.iconBox}>
              <Clock size={22} />
            </div>
            <div className={styles.infoContent}>
              <h3 className={styles.infoTitle}>Operational Hours</h3>
              <p className={styles.infoText}>
                Monday – Saturday: 9:00 AM – 9:00 PM IST
                <br />
                Sunday: 10:00 AM – 7:00 PM IST
              </p>
            </div>
          </div>

          <div className={styles.infoCard}>
            <div className={styles.iconBox}>
              <ShieldCheck size={22} />
            </div>
            <div className={styles.infoContent}>
              <h3 className={styles.infoTitle}>Salon Partner Hotline</h3>
              <p className={styles.infoText}>
                Are you a registered salon vendor? Priority merchant support is available 7 days a
                week.
              </p>
            </div>
          </div>
        </div>

        {/* Right Column: Contact Message Form */}
        <div className={styles.formCard}>
          <div className={styles.formHeader}>
            <h2 className={styles.formTitle}>Send Us a Message</h2>
            <p className={styles.formSubtitle}>
              Fill out the form below and our customer support team will reply within 2 hours.
            </p>
          </div>

          <ContactForm idPrefix="contact-page" />
        </div>
      </div>

      {/* Partner Invitation Strip */}
      <div className={styles.partnerBanner}>
        <div>
          <h3
            style={{
              fontSize: '1.25rem',
              fontWeight: 800,
              color: '#ffffff',
              margin: '0 0 0.35rem 0',
            }}
          >
            Looking to list your Barbershop or Salon?
          </h3>
          <p style={{ color: '#94a3b8', margin: 0, fontSize: '0.85rem' }}>
            Sign up for the B4BARBER partner network and start accepting appointments today.
          </p>
        </div>
        <a
          href="http://localhost:3004/login"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.btnPrimary}
        >
          <span>Partner Console</span>
          <ArrowRight size={15} />
        </a>
      </div>
    </div>
  );
};

export default ContactPage;
